import { AuthUser } from "../../data/auth/authUser";
import { apiGetRequest } from "../../utils/webrequests";

export async function getAuthUserProfile(): Promise<AuthUser>{
    const data:AuthUser = await apiGetRequest("UserProfile",null);
    return data;
};